import { render, staticRenderFns } from "./FormStaticNT.vue?vue&type=template&id=0d8f3af4&scoped=true"
import script from "./FormStaticNT.vue?vue&type=script&lang=js"
export * from "./FormStaticNT.vue?vue&type=script&lang=js"
import style0 from "./FormStaticNT.vue?vue&type=style&index=0&id=0d8f3af4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8f3af4",
  null
  
)

export default component.exports